import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import Contacts from '~/components/audiences/Tile/Contacts.svg';
import Prospects from '~/components/audiences/Tile/Prospects.svg';
import Visitors from '~/components/audiences/Tile/Visitors.svg';
import FacebookIcon from '~/images/services/Facebook.svg';
import GoogleIcon from '~/images/services/Google.svg';
import {
  adsDestinationTypes,
  destinationNameForType,
  destinationTypeCustomHtml,
  destinationTypeEmail,
  destinationTypeSalesforce,
  destinationTypeSlack,
  destinationTypeWebhook,
  shortDescriptionForType,
} from '~/lib/destinations';
import Logo from '~/pages/destinations/components/Logo';

import styles from './styles';

const articleForTitle = {
  Advertising: 'an',
  Alerting: 'an',
  Personalization: 'a',
};

function AddPlan({ classes, title, segment }) {
  const to = {
    pathname: `destinations/contact-success/${title.toLowerCase()}`,
  };

  let types = [];
  if (title === 'Advertising') {
    types = [
      {
        name: 'Prospect audiences',
        description: 'Find ideal customers & advertise to them',
        icon: <Prospects className={classes.logo} />,
      },
      {
        name: 'Site Visitor audiences',
        description: 'Advertise based on your website traffic',
        icon: <Visitors className={classes.logo} />,
      },
      {
        name: 'Contact audiences',
        description: 'Advertise to people in your database',
        icon: <Contacts className={classes.logo} />,
      },
    ].concat(
      adsDestinationTypes(segment.type).map((type) => ({
        name: destinationNameForType(type),
        description: shortDescriptionForType(type),
        icon: <Logo className={classes.logo} destinationType={type} />,
      })),
    );
  }
  if (title === 'Alerting') {
    types = [
      destinationTypeSlack,
      destinationTypeSalesforce,
      destinationTypeEmail,
      destinationTypeWebhook,
    ].map((type) => ({
      name: destinationNameForType(type),
      description: shortDescriptionForType(type),
      icon: <Logo className={classes.logo} destinationType={type} />,
    }));
  }
  if (title === 'Personalization') {
    types = [destinationTypeCustomHtml].map((type) => ({
      name: destinationNameForType(type),
      description: shortDescriptionForType(type),
      icon: <Logo className={classes.logo} destinationType={type} />,
    }));
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.titleContainer}>
          <span className={classes.title}>
            Add {articleForTitle[title]} {title} plan to your Clearbit account
          </span>
          <span className={classes.subTitle}>
            Send alerts and notifications to your teams with these destinations.
          </span>
        </div>
        <CKButton
          as={Link}
          classes={{
            root: classes.destinationButton,
          }}
          to={to}
          variant="bold"
          variantColor="blue"
        >
          Contact success team
        </CKButton>
      </div>
      <hr className={classes.separator} />
      <div className={classes.grid}>
        {types.map((type) => (
          <div className={classes.destinationItem} key={type.name}>
            {type.icon}
            <div className={classes.destinationTitleContainer}>
              <span className={classes.destinationTitle}>{type.name}</span>
              <span className={classes.destinationSubtitle}>
                {type.description}
              </span>
            </div>
          </div>
        ))}
      </div>

      {title === 'Advertising' && (
        <>
          <hr className={classes.separator} />
          <div className={classes.footer}>
            <FacebookIcon className={classes.footerServiceIcon} />
            <GoogleIcon className={classes.footerServiceIcon} />
            <span className={classes.footerText}>
              Sync with Facebook Custom Audiences, Facebook Retargeting and
              Google Remarketing
            </span>
          </div>
        </>
      )}
    </div>
  );
}

AddPlan.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddPlan);
